var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.469849,
    y: 0.5,
    width: 63,
    height: 63,
    rx: 31.5,
    fill: "#0E6AC7",
    fillOpacity: 0.8
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_876_333)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_876_333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5824 31.2124L28.0324 40.6624L45.3574 23.3374",
    stroke: "#062C80",
    strokeWidth: 4.725,
    strokeMiterlimit: 10
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_876_333"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.075,
    height: 23.625,
    fill: "white",
    transform: "translate(15.4324 20.1875)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_876_333"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.075,
    height: 23.625,
    fill: "white",
    transform: "translate(15.4324 20.1875)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/Check.6abb2ae97128693dbabb7dd40a2633f9.svg";
export { ForwardRef as ReactComponent };